import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MdePopoverModule } from "@material-extended/mde";
import { ErrorMessageHandler } from "@smallstack/common-components";
import { SmallstackThemeModule } from "@smallstack/theme-components";
import { FlagComponent } from "./components/flag/flag.component";
import { HumanizedTimeComponent } from "./components/humanized-time/humanized-time.component";
import { I18nComponent } from "./components/i18n/i18n.component";
import { InlineTranslationEditorComponent } from "./components/inline-translation-editor/inline-translation-editor.component";
import { LocaleSelectorViewComponent } from "./components/locale-selector/locale-selector-view.component";
import { LocaleSelectorComponent } from "./components/locale-selector/locale-selector.component";
import { NotificationDialogComponent } from "./components/notification-dialog/notification-dialog.component";
import { SmallstackCurrencyComponent } from "./components/smallstack-currency/smallstack-currency.component";
import { SmallstackDateComponent } from "./components/smallstack-date/smallstack-date.component";
import { SmallstackDurationComponent } from "./components/smallstack-duration/smallstack-duration.component";
import { TranslationsPopoverComponent } from "./components/translations-popover/translations-popover.component";
import { currentLocale$, CURRENT_LOCALE$, fallbackChains, FALLBACK_CHAINS } from "./services/locale.service";
import { NotificationService } from "./services/notification.service";
import { MaterialDialogNotifier } from "./services/notifiers/material-dialog.notifier";
import { MaterialSnackbarNotifier } from "./services/notifiers/material-snackbar.notifier";
import { TranslationLoader } from "./utils/translation-loader";
import * as i0 from "@angular/core";
export class SmallstackI18nModule {
}
SmallstackI18nModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackI18nModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmallstackI18nModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.5", ngImport: i0, type: SmallstackI18nModule, declarations: [FlagComponent,
        I18nComponent,
        LocaleSelectorComponent,
        LocaleSelectorViewComponent,
        NotificationDialogComponent,
        TranslationsPopoverComponent,
        InlineTranslationEditorComponent,
        SmallstackCurrencyComponent,
        SmallstackDateComponent,
        SmallstackDurationComponent,
        HumanizedTimeComponent], imports: [CommonModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MdePopoverModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        SmallstackThemeModule], exports: [FlagComponent,
        I18nComponent,
        LocaleSelectorComponent,
        NotificationDialogComponent,
        TranslationsPopoverComponent,
        InlineTranslationEditorComponent,
        SmallstackCurrencyComponent,
        SmallstackDateComponent,
        SmallstackDurationComponent,
        HumanizedTimeComponent] });
SmallstackI18nModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackI18nModule, providers: [
        { provide: MAT_DATE_LOCALE, useValue: "de" },
        { provide: DateAdapter, useClass: MomentDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        {
            provide: CURRENT_LOCALE$,
            useValue: currentLocale$
        },
        {
            provide: FALLBACK_CHAINS,
            useValue: fallbackChains
        },
        TranslationLoader,
        ErrorMessageHandler,
        MaterialDialogNotifier,
        MaterialSnackbarNotifier,
        NotificationService
    ], imports: [CommonModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatMenuModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MdePopoverModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        SmallstackThemeModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackI18nModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FlagComponent,
                        I18nComponent,
                        LocaleSelectorComponent,
                        LocaleSelectorViewComponent,
                        NotificationDialogComponent,
                        TranslationsPopoverComponent,
                        InlineTranslationEditorComponent,
                        SmallstackCurrencyComponent,
                        SmallstackDateComponent,
                        SmallstackDurationComponent,
                        HumanizedTimeComponent
                    ],
                    imports: [
                        CommonModule,
                        FlexLayoutModule,
                        FormsModule,
                        MatButtonModule,
                        MatCardModule,
                        MatDialogModule,
                        MatMenuModule,
                        MatSlideToggleModule,
                        MatSnackBarModule,
                        MdePopoverModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatMenuModule,
                        SmallstackThemeModule
                    ],
                    exports: [
                        FlagComponent,
                        I18nComponent,
                        LocaleSelectorComponent,
                        NotificationDialogComponent,
                        TranslationsPopoverComponent,
                        InlineTranslationEditorComponent,
                        SmallstackCurrencyComponent,
                        SmallstackDateComponent,
                        SmallstackDurationComponent,
                        HumanizedTimeComponent
                    ],
                    providers: [
                        { provide: MAT_DATE_LOCALE, useValue: "de" },
                        { provide: DateAdapter, useClass: MomentDateAdapter },
                        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
                        {
                            provide: CURRENT_LOCALE$,
                            useValue: currentLocale$
                        },
                        {
                            provide: FALLBACK_CHAINS,
                            useValue: fallbackChains
                        },
                        TranslationLoader,
                        ErrorMessageHandler,
                        MaterialDialogNotifier,
                        MaterialSnackbarNotifier,
                        NotificationService
                    ]
                }]
        }] });
